<template>
	<div class="fuel container-fluid py-4" v-if="plant.PlantNo">
		<div class="row">
			<H5>{{plant.BOSStationId ? plant.BOSStationId : (plant.BranchId ? plant.BranchId : plant.PlantNo)}} - {{plant.PlantName}}</H5>
		</div>
		<div class="row">
			<PlantFuel :plant="plant.PlantNo" :station="plant.StationId" />
		</div>
		<div class="row" v-for="(item, index) in this.store" :key="index">
			<H5>{{item.BranchId}} - {{item.BranchName}}</H5>
			<PlantBright :branchid="item.BranchId" />
		</div>
		<div class="row">
			<PlantLPG />
		</div>
		<div class="row">
			<PlantFinance :plant="plant.PlantNo" />
		</div>
		<Footer/>
	</div>
</template>

<script>
import Plant from '@/components/page/Plant.js'
import PlantFuel from '@/views/pages/PlantFuel.vue'
import PlantBright from '@/views/pages/PlantBright.vue'
import PlantLPG from '@/views/pages/PlantLPG.vue'
import Footer from '@/views/Footer.vue'
import PlantFinance from '@/views/pages/PlantFinance.vue'

export default{
	extends: Plant,
	components:{
		PlantFuel,
		PlantBright,
		PlantLPG,
		PlantFinance,
		Footer            
	},
    mounted(){
		this.loadPlant(this.$route.query.plant, this.$route.query.station);
		this.loadStoreList(this.$route.query.plant, this.$route.query.station);
    },
    methods:{
	}
}

</script>